// eslint-disable-next-line import/prefer-default-export
export const identityRegion = 'us-east-1';
export const dashboardRegion = 'us-east-1';
export const defaultDashboardName = 'PDW Announcements';
export const incompatibleMessage = 'IE browser is not compatible with this application - Please use chrome/firefox/Edge';
export const successMessage = 'Request Submitted Successfully';
export const errorMessage = 'Internal Server Error';
export const reportErrorMessage = 'Unable to fetch dashboard';
export const searchErrorMessage = 'No report found for this search';
export const noDashboardH1 = 'If you are a McDonald’s corporate or field employee, please follow the instructions below:';
export const supportText = ' send an email to Derek Berube at ';
export const noDashboardH1L1 = '1. Login to Service Café and open a support ticket.';
export const noDashboardH1L2 = '2. Click the “Need Assistance” box on the main SC page.';
export const noDashboardH1L3 = '3. Select Global Role Manager (Global RM) in Business Service.';
export const noDashboardH2 = 'If you are a member of a Franchisee Organization or are a McOpCo Ops Manager, Supervisor or Restaurant Manager, ';
export const supportAtos = 'please call ATOS Helpdesk for assistance.';
